var map = {
	"./a023-short1.jpg": 275,
	"./a023-short2.jpg": 276,
	"./a023-short3.jpg": 277,
	"./a023-short4.jpg": 278,
	"./a023-short5.jpg": 279,
	"./a023-short6.jpg": 280
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3051;